import ButtonTransmitReport from './ButtonTransmitReport';

export default ButtonTransmitReport;
